module.exports = RootreeVendor.ReactDOM;